import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { getConsent, setConsent } from '@/lib/consent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsent() === null);
    const onChange = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setVisible(detail === null);
    };
    window.addEventListener('consent-changed', onChange);
    return () => window.removeEventListener('consent-changed', onChange);
  }, []);

  const accept = () => {
    setConsent('accepted');
    setVisible(false);
  };

  const decline = () => {
    setConsent('declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed bottom-4 right-4 left-4 sm:left-auto z-50 w-auto sm:w-[22rem] border border-border bg-background/95 backdrop-blur p-4 shadow-lg"
    >
      <p className="text-sm text-muted-foreground">
        We use cookies for authentication and security. With your consent
        we also enable error reporting and anonymous visitor analytics to improve the site.{' '}
        <a href="/privacy-policy" className="underline hover:text-foreground">
          Privacy Policy
        </a>
      </p>
      <div className="flex gap-2 mt-3">
        <Button size="sm" onClick={accept}>
          Accept
        </Button>
        <Button size="sm" variant="outline" onClick={decline}>
          Decline
        </Button>
      </div>
    </div>
  );
}
